import { useRouteError, isRouteErrorResponse, useNavigate } from 'react-router';
import { AlertTriangle, Home, RotateCcw } from 'lucide-react';

export default function ErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();
  const is404 = isRouteErrorResponse(error) && error.status === 404;

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f8f8fa] px-4" style={{ fontFamily: 'var(--font-primary)' }}>
      <div className="max-w-md text-center">
        <div
          className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full"
          style={{ backgroundColor: is404 ? '#f0e8ff' : '#fff3e6' }}
        >
          <AlertTriangle className="h-10 w-10" style={{ color: is404 ? '#3b0b86' : '#ff6417' }} />
        </div>

        <h1 className="mb-2 text-3xl font-bold" style={{ color: '#3b0b86' }}>
          {is404 ? 'Pagina nu a fost găsită' : 'Ceva nu a mers bine'}
        </h1>

        <p className="mb-8 text-sm text-muted-foreground" style={{ fontFamily: 'var(--font-secondary)' }}>
          {is404
            ? 'Pagina pe care o cauți nu există sau a fost mutată.'
            : 'A apărut o eroare neașteptată. Te rugăm să încerci din nou.'}
        </p>

        <div className="flex justify-center gap-3">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 rounded-lg bg-[var(--vivid-purple)] px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[var(--vivid-purple)]/90"
          >
            <Home className="h-4 w-4" />
            Acasă
          </button>
          {!is404 && (
            <button
              onClick={() => window.location.reload()}
              className="flex items-center gap-2 rounded-lg border border-[var(--vivid-purple)] px-5 py-2.5 text-sm font-semibold text-[var(--vivid-purple)] transition-colors hover:bg-[var(--vivid-purple)]/5"
            >
              <RotateCcw className="h-4 w-4" />
              Reîncearcă
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
